<template>
  <v-dialog max-width="520">
    <template v-slot:activator="{ props: activatorProps }">
      <slot name="activator" :props="activatorProps">
        <v-btn v-bind="activatorProps" variant="flat" color="primary"
          ><v-icon class="mr-2">mdi-heart</v-icon>Doneer</v-btn
        >
      </slot>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card class="donate-card">
        <div class="donate-header">
          <h2 class="donate-title">Doneer nu</h2>
          <v-btn
            icon="mdi-close"
            variant="text"
            color="white"
            density="comfortable"
            @click="isActive.value = false"
          ></v-btn>
        </div>

        <div class="donate-body" v-if="!send">
          <div class="name-grid">
            <v-text-field
              variant="solo"
              flat
              rounded="lg"
              bg-color="smoke"
              label="Voornaam"
              hide-details=""
              v-model="donation.firstName"
            ></v-text-field>
            <v-text-field
              v-model="donation.lastName"
              variant="solo"
              flat
              rounded="lg"
              bg-color="smoke"
              label="Achternaam"
              hide-details=""
            ></v-text-field>
          </div>
          <v-text-field
            class="mt-3"
            v-model="donation.email"
            variant="solo"
            flat
            rounded="lg"
            hide-details=""
            bg-color="smoke"
            label="E-mail"
          ></v-text-field>

          <p class="donate-label">
            Kies uw {{ donation.recurring }}e bijdrage:
          </p>
          <div class="amount-grid">
            <button
              v-for="a in amounts"
              :key="a.value"
              class="amount-chip"
              :class="{ active: donation.value === a.value }"
              @click="donation.value = a.value"
            >
              {{ a.value > 0 ? `€ ${a.value}` : "Anders" }}
            </button>
          </div>
        </div>

        <div class="donate-success" v-else>
          <span class="success-icon">✓</span>
          <p class="success-text">
            <b>Hartelijk dank voor uw donatie!</b> Onze donatie-link opent
            automatisch in een nieuw tabblad.
          </p>
          <button class="ws-btn ws-btn--ghost" @click="retry">
            Probeer opnieuw
          </button>
        </div>

        <div class="donate-footer" v-if="!send">
          <button
            class="ws-btn ws-btn--primary donate-submit"
            :disabled="
              !donation.value ||
              !donation.recurring ||
              !donation.firstName ||
              !donation.lastName ||
              !donation.email
            "
            @click="doneer"
          >
            <span class="heart">♥</span> Doneer
          </button>
        </div>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { collection, addDoc } from "firebase/firestore";
import { db } from "@/firebase";
export default {
  data() {
    return {
      amounts: [
        {
          link: "https://betaalverzoek.rabobank.nl/betaalverzoek/?id=W_v-JJSBTxOtQCGxuKlkKQ",
          value: 50,
        },
        {
          value: 35,
          link: "https://betaalverzoek.rabobank.nl/betaalverzoek/?id=84GCnVubQ_iLRzcHscj5Ng",
        },
        {
          value: 25,
          link: "https://betaalverzoek.rabobank.nl/betaalverzoek/?id=iImFJhKeSaeWZ2VMIM7lwQ",
        },
        {
          value: 15,
          link: "https://betaalverzoek.rabobank.nl/betaalverzoek/?id=vQXbGGHQR8WavfOOQD34sg",
        },
        {
          value: "Anders",
          link: "https://betaalverzoek.rabobank.nl/betaalverzoek/?id=176fBEGMSleC4cxQi-VkTw",
        },
      ],
      send: false,
      donation: {
        firstName: null,
        lastName: null,
        email: null,
        value: null,
        recurring: "eenmalig",
        date: Math.floor(Date.now() / 1000),
      },
    };
  },
  methods: {
    async doneer() {
      await addDoc(collection(db, "donaties"), this.donation);

      if (this.donation.recurring === "eenmalig") {
        this.openLink(
          this.amounts.find((a) => a.value === this.donation.value).link
        );
        this.send = true;
      }
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    retry() {
      this.openLink(
        this.amounts.find((a) => a.value === this.donation.value).link
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.donate-card {
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 30px 70px -20px rgba(60, 36, 21, 0.5) !important;
}

.donate-header {
  background: linear-gradient(160deg, #ea6b26, #d2541a);
  padding: 18px 16px 18px 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.donate-title {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 24px;
  color: #fff;
  letter-spacing: -0.01em;
}

.donate-body {
  padding: 24px 26px 8px;
}
.name-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.donate-label {
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #6b5d52;
  margin: 22px 0 12px;
}

.amount-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.amount-chip {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 15px;
  color: #2a2018;
  background: #f1e7dc;
  border: 1.5px solid transparent;
  border-radius: 12px;
  padding: 12px 22px;
  cursor: pointer;
  transition: background var(--ws-dur-fast) var(--ws-ease-out),
    border-color var(--ws-dur-fast) var(--ws-ease-out),
    color var(--ws-dur-fast) var(--ws-ease-out),
    transform var(--ws-dur-press) var(--ws-ease-out);
}
.amount-chip:hover {
  border-color: rgba(234, 107, 38, 0.4);
}
.amount-chip:active {
  transform: scale(0.96);
}
.amount-chip.active {
  background: #ea6b26;
  color: #fff;
  box-shadow: 0 8px 18px rgba(234, 107, 38, 0.32);
}

.donate-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 26px 24px;
}
.donate-submit {
  padding: 13px 30px;
  .heart {
    font-size: 16px;
  }
}
.donate-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.donate-success {
  padding: 32px 30px 34px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
.success-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fbe3d2;
  color: #c2541a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 900;
}
.success-text {
  font-size: 16px;
  line-height: 1.6;
  color: #5c4f44;
}

@media screen and (max-width: 480px) {
  .name-grid {
    grid-template-columns: 1fr;
  }
}
</style>
